enum PackageBuyerOptions {
  AvailableToAllBuyers = 'AvailableToAllBuyers', // TODO: Rename to AvailableToAllHivestackBuyers
  AvailableToAllExternalBuyers = 'AvailableToAllExternalBuyers', // TO BE REMOVED SOON
  AvailableToSpecificBuyers = 'AvailableToSpecificBuyers', // Restricted DSPs
  AvailableToSpecificDsps = 'AvailableToSpecificDsps', // External exchanges
  AvailableToSpecificCurators = 'AvailableToSpecificCurators', // Restricted curators
}

export default PackageBuyerOptions;
